import { useEffect, useState, Component } from 'react';
import '../../scss/backoffice.scss';
import { Sidemenu } from './Sidemenu';
import { Topbar } from './Topbar';
import { Footer } from './Footers';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Switch from 'react-switch';
import { FileUploader } from 'react-drag-drop-files';
import { Badge } from '../../components/backend/Badge';
import { GetSalaryRequest } from '../../services/ApiGetSalaryRequest';
import { RequestDetailModal, ImportResult } from '../../model/datatype';
import Moment from 'moment';
import ReactPaginate from 'react-paginate';
import * as FileSaver from 'file-saver';
import * as Excel from 'exceljs';
import { InputGroup, Form, Alert, Table } from 'react-bootstrap';
import { UploadExcelMasterFile } from '../../services/ApiPostExcelMasterFile';
import { UpdateAdvanceSalaryRequest } from '../../services/ApiUpdateAdvanceSalaryRequest';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment-timezone';
import ProgressBar from 'react-bootstrap/ProgressBar';
import ReactTooltip from 'react-tooltip';
const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';
const fileTypes = ['xlsx'];
let importExts: any = [];
let importFails: any = [];
let arrimportSuccess: any = [];

export const Salary = (props: any) => {
  const [templateError, setTemplateError] = useState('');
  const [pageLoder, setPageLoder] = useState(false);
  const [resultActive, setResultActive] = useState(false);
  const [importInfo, setImportInfo] = useState<ImportResult | null>(null);
  const [uploading, setUploading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [uploadModalShow, setUploadModalShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [search, setSearch] = useState('');
  const current_year = new Date().getFullYear();
  const current_month = new Date().getMonth() + 1;
  const [loder, setLoader] = useState(true);
  const [filter, setFilter] = useState({
    year: current_year,
    month: current_month,
    status: 10,
    search: '',
    perpage: 10,
    offset: 0,
  });
  const [requestLists, setRequestLists] = useState<[RequestDetailModal] | null>(
    null,
  );
  const [requestListsAll, setRequestListsAll] = useState<
    [RequestDetailModal] | null
  >(null);
  const [requestItem, setRequestItem] = useState<RequestDetailModal | null>(
    null,
  );
  const years: any = [];
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 1,
    totalCount: 0,
  });
  const [bathFile, setBathFile] = useState(-1);
  const [fileImport, setFileImport] = useState(null);
  const [limit, setLimit] = useState(100);
  const [importOffset, setImportOffset] = useState(0);
  const [offset, setOffset] = useState(0);
  const [offsetAll, setOffsetAll] = useState(10);
  const [totalImport, setTotalImport] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [importSuccess, setImportSuccess] = useState(0);
  const [importStatus, setImportStatus] = useState(false);
  const [progress, setProgress] = useState(0);
  const [pagesSelected, setPagesSelected] = useState(0);
  const [editModalShow, setEditModalShow] = useState(false);
  const [editRow, setEditRow] = useState<any>(null);
  const [editRemark, setEditRemark] = useState('');
  const [editStatus, setEditStatus] = useState<number>(0);

  const statusOptions = [
    { value: 0, label: 'Pending' },
    { value: 1, label: 'Approved' },
    { value: 9, label: 'Rejected' },
  ];

  for (let startY = current_year; startY > current_year - 4; startY--) {
    years.push(startY);
  }

  const setInputValue = (e: any) => {
    const { name, value } = e.target;
    //setFilter((oldValues: any) => ({ ...oldValues, ['offset']: 0 }));
    //setFilter((oldValues: any) => ({ ...oldValues, [name]: value }));
    if (name !== 'search') {
      setFilter((oldValues: any) => ({ ...oldValues, ['offset']: 0 }));
      setFilter((oldValues: any) => ({ ...oldValues, [name]: value }));
      setRequestLists(null);
      setOffset(0);
    } else {
      setSearch(value);
    }
  };
  const onEnterSearch = (e: any) => {
    //
    const { name, value } = e.target;
    if (name === 'search' && e.key === 'Enter') {
      setRequestLists(null);
      setFilter((oldValues: any) => ({ ...oldValues, ['search']: value }));
      setFilter((oldValues: any) => ({ ...oldValues, ['offset']: 0 }));
    }
  };
  const onClickSearch = (e: any) => {
    setRequestLists(null);
    setFilter((oldValues: any) => ({ ...oldValues, ['search']: search }));
  };

  let helpModalClose = () => {
    setUploadModalShow(false);
    setModalShow(false);
    console.log('close');
    setImportInfo(null);
    setRequestLists(null);
    setTemplateError('');
  };

  const handleChange = (file: any) => {
    setUploading(true);
    setFileImport(file);
    setBathFile(1);
  };
  const handleClickImport = () => {
    importExts = [];
    importFails = [];
    arrimportSuccess = [];
    setImportInfo(null);
    setImportStatus(false);
    setImportOffset(0);
    setTotalImport(1);
    setProgress(0);
    setUploadModalShow(true);
  };
  const handleExport = () => {
    console.log('Export');
  };
  const handlePageClick = (event: any) => {
    setRequestLists(null);
    const newOffset = (event.selected * filter.perpage) % pagination.totalCount;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`,
    );
    setPagesSelected(event.selected);
    setOffset(newOffset);
    // console.log('newOffset=',newOffset)
    // setOffsetAll(newOffset)
    // console.log('offsetAll=',offsetAll);
    setFilter((oldValues: any) => ({ ...oldValues, ['offset']: newOffset }));
  };
  const onView = (item: any) => {
    setRequestItem(item);
    setModalShow(true);
  };
  const exportToExcel = async () => {
    setPageLoder(true);
    
    try {
      // สร้าง timestamp ล่วงหน้า
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const formattedDateTime = `_${day}_${month}_${year}_${hours}${minutes}${seconds}`;
      
      // ดึงข้อมูลแบบ async/await
      const response = await GetSalaryRequest(filter, 'no');
      const resultGet = response.advanceSalaryRequests;
      
      if (!resultGet || resultGet.length === 0) {
        setPageLoder(false);
        return;
      }

      // สร้าง workbook และ worksheet
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet('SalaryRequest', {
        views: [{ state: 'frozen', ySplit: 1 }],
      });

      // กำหนด columns พร้อม style แบบเดียว
      const columns = [
        { header: 'Emp ID', width: 14, key: 'employeeId' },
        { header: 'Employee', key: 'employeeName', width: 50 },
        { header: 'Department', key: 'department', width: 50 },
        { header: 'Amount', key: 'requestAmount', width: 30 },
        { header: 'Status', width: 20, key: 'status' },
        { header: 'Approved Amount', width: 30, key: 'approveAmount' },
        { header: 'Remark', width: 60, key: 'remark' },
        { header: 'Request Date', width: 30, key: 'requestDate' },
        { header: 'Year', width: 30, key: 'year' },
        { header: 'Month', width: 30, key: 'month' },
      ];

      worksheet.columns = columns;

      // เตรียมข้อมูลทั้งหมดก่อนแล้วค่อยเพิ่มในครั้งเดียว
      const rows = resultGet.map((item: any) => ({
        employeeId: item.employeeId,
        employeeName: item.employeeName,
        department: item.department,
        requestAmount: item.requestAmount,
        status: item.statusStr,
        approveAmount: item.approvedAmount,
        remark: item.remark,
        requestDate: moment(item.requestDate + 'Z')
          .tz(timezoneStr)
          .format('DD-MM-YYYY HH:mm:ss'),
        year: item.year,
        month: item.month,
      }));

      // เพิ่มข้อมูลทั้งหมดในครั้งเดียว
      worksheet.addRows(rows);

      // จัดการ header style แบบ loop
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      
      // สร้างไฟล์และดาวน์โหลด
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const fileName = `AdvanceSalaryRequest${formattedDateTime}.xlsx`;
      FileSaver.saveAs(blob, fileName);
      
    } catch (error) {
      console.error('Export error:', error);
    } finally {
      setPageLoder(false);
    }
  };
  useEffect(() => {
    if (requestLists === null) {
      //setPagination({ totalPage: 0, currentPage: 1, totalCount: 0 })
      //console.log(filter);
      GetSalaryRequest(filter, 'yes').then((response: any) => {
        const getData: any = response;
        console.log('getData=', getData);
        setRequestLists(getData.advanceSalaryRequests);
        if (offset === 0) {
          setPagesSelected(0);
        }
        setPagination({
          totalPage: getData.totalPages,
          currentPage: 1,
          totalCount: getData.totalCount,
        });
        setLoader(false);
      });
    }
    if (bathFile > 0 && (bathFile - 1) * limit < totalImport) {
      UploadExcelMasterFile(fileImport, limit, importOffset, bathFile)
        .then((response: any) => {
          const getData: any = response;
          console.log(getData);
          if (getData.status === 200) {
            importExts = importExts.concat(
              getData.data.advanceSalaryRequestExts,
            );
            importFails = importFails.concat(
              getData.data.importResult.importFails,
            );
            arrimportSuccess = arrimportSuccess.concat(
              getData.data.importResult.importSuccesses,
            );

            setTotalCount(getData.data.totalCount);
            setImportOffset(bathFile * limit);
            //setUploading(false)

            setFile(fileImport);
            setTotalImport(getData.data.totalCount);
            if (bathFile * limit >= parseInt(getData.data.totalCount)) {
              let impInfo: any = {
                AdvanceSalaryRequestExts: importExts,
                importResult: {
                  importFails: importFails,
                  importSuccesses: arrimportSuccess,
                },
              };
              setImportInfo(impInfo);
              setImportStatus(true);
              setUploading(false);
              console.log('Failes=>', importInfo);
            }
          } else {
            setFile(fileImport);
            setUploadModalShow(false);
          }

          let current: number = bathFile * limit;
          let percent: number =
            (current / parseInt(getData.data.totalCount)) * 100;
          setProgress(percent > 100 ? 100 : percent);
          setBathFile(bathFile + 1);
        })
        .catch((error: any) => {
          console.log(error);
          setUploading(false);
          setTemplateError(error.toString());
          setBathFile(bathFile + 1);
        });
    }
  }, [filter, requestLists, bathFile, importInfo]);
  const handleEditClick = (item: any) => {
    setEditRow(item);
    setEditRemark(item.remark || '');
    setEditStatus(item.status);
    setEditModalShow(true);
  };

  const handleEditModalClose = () => {
    setEditModalShow(false);
    setEditRow(null);
    setEditRemark('');
    setEditStatus(0);
  };

  const handleEditSave = async () => {
    if (!editRow) return;
    const updateParams: any = {
      employeeId: editRow.employeeId,
      year: editRow.year,
      month: editRow.month,
    };
    if (editRemark !== editRow.remark) updateParams.remark = editRemark;
    if (editStatus !== editRow.status) updateParams.status = editStatus;
    try {
      await UpdateAdvanceSalaryRequest(updateParams);
      setRequestLists((prev: any) =>
        prev
          ? prev.map((row: any) =>
              row === editRow
                ? { ...row, remark: editRemark, status: editStatus, statusStr: statusToStr(editStatus) }
                : row
            )
          : prev
      );
      toast.success('Updated successfully');
      setEditModalShow(false);
    } catch (err) {
      toast.error('Update failed');
    }
  };

  const statusToStr = (status: number) => {
    switch (status) {
      case 0:
        return 'Pending';
      case 1:
        return 'Approved';
      case 9:
        return 'Rejected';
      default:
        return '';
    }
  };
  return (
    <>
      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Adv. Salary Requests</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-2">
                  <div className="row px-4 border-bottom pb-4 filter-block">
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="form-group">
                        <label className="mb-2">MONTH</label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="month"
                          onChange={setInputValue}
                          defaultValue={current_month}
                        >
                          <option
                            value={1}
                            selected={filter.month === 1 ? true : false}
                          >
                            January
                          </option>
                          <option
                            value={2}
                            selected={filter.month === 2 ? true : false}
                          >
                            February
                          </option>
                          <option
                            value={3}
                            selected={filter.month === 3 ? true : false}
                          >
                            March
                          </option>
                          <option
                            value={4}
                            selected={filter.month === 4 ? true : false}
                          >
                            April
                          </option>
                          <option
                            value={5}
                            selected={filter.month === 5 ? true : false}
                          >
                            May
                          </option>
                          <option
                            value={6}
                            selected={filter.month === 6 ? true : false}
                          >
                            June
                          </option>
                          <option
                            value={7}
                            selected={filter.month === 7 ? true : false}
                          >
                            July
                          </option>
                          <option
                            value={8}
                            selected={filter.month === 8 ? true : false}
                          >
                            August
                          </option>
                          <option
                            value={9}
                            selected={filter.month === 9 ? true : false}
                          >
                            September
                          </option>
                          <option
                            value={10}
                            selected={filter.month === 10 ? true : false}
                          >
                            October
                          </option>
                          <option
                            value={11}
                            selected={filter.month === 11 ? true : false}
                          >
                            November
                          </option>
                          <option
                            value={12}
                            selected={filter.month === 12 ? true : false}
                          >
                            December
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="form-group">
                        <label className="mb-2">YEAR</label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="year"
                          onChange={setInputValue}
                          defaultValue={current_year}
                        >
                          {years.map((year: any) => (
                            <option
                              key={`y${year}`}
                              value={year}
                              selected={filter.year === year ? true : false}
                            >
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="form-group">
                        <label className="mb-2">STATUS</label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="status"
                          onChange={setInputValue}
                          defaultValue={10}
                        >
                          <option
                            value="10"
                            selected={filter.status === 10 ? true : false}
                          >
                            All
                          </option>
                          <option
                            value="0"
                            selected={filter.status === 0 ? true : false}
                          >
                            Pending
                          </option>
                          <option
                            value="9"
                            selected={filter.status === 9 ? true : false}
                          >
                            Rejected
                          </option>
                          <option
                            value="1"
                            selected={filter.status === 1 ? true : false}
                          >
                            Approved
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row my-3 px-4 pt-3 filter-block">
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="d-flex">
                        <label className="mt-2">Show </label>
                        <select
                          className="form-select w-auto ms-2"
                          aria-label="Default select example"
                          name="perpage"
                          onChange={setInputValue}
                          defaultValue={10}
                        >
                          <option
                            value={10}
                            selected={filter.perpage === 10 ? true : false}
                          >
                            10
                          </option>
                          <option
                            value={20}
                            selected={filter.perpage === 20 ? true : false}
                          >
                            20
                          </option>
                          <option
                            value={30}
                            selected={filter.perpage === 30 ? true : false}
                          >
                            30
                          </option>
                          <option
                            value={40}
                            selected={filter.perpage === 40 ? true : false}
                          >
                            40
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-8 col-md-8">
                      <div className="d-flex justify-content-end">
                        <div className="d-flex">
                          <label className="mt-2 me-2" data-tip="hello world">
                            Search{' '}
                          </label>
                          <InputGroup>
                            <Form.Control
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              placeholder="employee ID or name"
                              name="search"
                              onChange={setInputValue}
                              onKeyDown={onEnterSearch}
                            />
                            <Button
                              variant="outline-secondary btn-search-icon"
                              id="button-addon2"
                              onClick={onClickSearch}
                            >
                              <img
                                src="../../../images/backoffice/search.png"
                                width={20}
                                alt="Search icon"
                              />
                            </Button>
                          </InputGroup>
                        </div>
                        <Button
                          className="btn-import ms-3"
                          onClick={() => handleClickImport()}
                        >
                          <img src="../../../images/backoffice/file-text.png" alt="Import file icon" />{' '}
                          Import
                        </Button>
                        <Button
                          className="btn-import ms-3"
                          onClick={() => exportToExcel()}
                        >
                          <img src="../../../images/backoffice/external-link.png" alt="Export file icon" />{' '}
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                  <table className="table hr-table">
                    <thead>
                      <tr>
                        <th>Req Date</th>
                        <th>Emp id</th>
                        <th>Name</th>
                        <th>Requests</th>
                        <th>Approved</th>
                        <th>Action Date</th>
                        <th className="text-center">STATUS</th>
                        {/* <th className="text-center w-25">Remark</th> */}
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requestLists ? (
                        requestLists.map((item: any, key: number) => (
                          <tr key={`tr-${key}`}>
                            <td>
                              {Moment(item.requestDate + 'Z')
                                .tz('Asia/Bangkok')
                                .format('DD-MM-YYYY')}
                            </td>
                            <td>{item.employeeId}</td>
                            <td>{item.employeeName}</td>
                            <td className="text-center">
                              {item.requestAmountStr}
                            </td>
                            <td className="text-center">
                              {item.approveAmountStr}
                            </td>
                            <td>
                              {item.actionDateTime !== null
                                ? moment(item.actionDateTime + 'Z')
                                    .tz('Asia/Bangkok')
                                    .format('DD-MM-YYYY HH:mm:ss')
                                : ''}
                            </td>
                            <td className="text-center">
                              <Badge
                                status={item.statusStr}
                                text={item.statusStr}
                              />
                            </td>
                            {/* <td className="">{item?.remark} </td> */}
                            {/* <td
                              className="text-truncate"
                              data-tip={item?.remark}
                            >
                              {item?.remark}
                              <ReactTooltip
                                className="overrideMe"
                                multiline={true}
                                place="bottom"
                                type="success"
                              />
                            </td> */}
                            <td className="text-center">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditClick(item)}
                                style={{ minWidth: 60 }}
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9} className="tr_loding">
                            {loder ? (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <ReactPaginate
                    forcePage={pagesSelected}
                    breakLabel="..."
                    nextLabel="&raquo;"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pagination.totalPage}
                    previousLabel="&laquo;"
                    className="pagination justify-content-end hr-pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="prevPage"
                    nextClassName="nextPage"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    activeLinkClassName="link-active"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Request Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 request-detail">
          <div className="row border-bottom">
            <div className="col-12 col-sm-9 col-md-9 mb-3">
              <h4 className="emp-name">
                {requestItem?.employeeName} ({requestItem?.employeeId})
              </h4>
              <p className="p-date">
                <img src="../../../images/backoffice/calendar.png" width={20} alt="Calendar icon" />{' '}
                {Moment(requestItem?.requestDate).format('DD-MM-YYYY')}
              </p>
            </div>
            <div className="col-12 col-sm-3 col-md-3 mb-3">
              <span
                className={`badge badge-pill hr-badge-${requestItem?.statusStr.toLowerCase()} float-end`}
              >
                {requestItem?.statusStr}
              </span>
            </div>
          </div>
          <div className="row border-bottom py-4">
            <div className="col-12 col-sm-8 col-md-8 mb-4">
              <div className="d-flex">
                <img src="../../../images/backoffice/request.png" width={60} alt="Request icon" />
                <div className="ms-3">
                  <label className="lb-request">Request</label>
                  <p>จำนวนเงินที่ต้องการเบิกล่วงหน้า</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-4 col-md-4 mb-4 text-end">
              <label className="lb-request-total">
                {requestItem?.requestAmountStr}
              </label>
            </div>
            <div className="col-12 col-sm-8 col-md-8">
              <div className="d-flex">
                <img src="../../../images/backoffice/approved.png" width={60} alt="Approved icon" />
                <div className="ms-3">
                  <label className="lb-request">Approved</label>
                  <p>จำนวนเงินที่ได้รับอนุมัติแล้ว</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-4 col-md-4 text-end">
              <label className="lb-approved-total">
                {requestItem?.approveAmountStr}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 py-3">
              <label className="font-weigth-bold">Remark</label>
              <p>{requestItem?.remark}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={uploadModalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Upload Excel File
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          {templateError !== '' ? (
            <Alert key="danger" variant="danger" className="message p-2">
              {templateError}
            </Alert>
          ) : (
            <>
              {importStatus &&
              importInfo &&
              importInfo?.importResult.importFails.length > 0 ? (
                <>
                  <div className="container mb-4">
                    <div className="row">
                      <div className="col-6 col-sm-6 col-md-6 ps-0">
                        <div className="block-shadow all-request h-100 import-result">
                          <div className="row align-items-center h-100">
                            <div className="col-8 ps-5">
                              <label className="text-success">
                                {
                                  importInfo?.importResult.importSuccesses
                                    .length
                                }
                              </label>
                              <p className="mb-0 text-success">
                                Import Successes
                              </p>
                            </div>
                            <div className="col-4 text-center">
                              <img
                                src="../../../images/backoffice/success.png"
                                width={50}
                                alt="Success icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-sm-6 col-md-6 pe-0">
                        <div
                          className={`block-shadow all-request h-100 import-result ${
                            resultActive ? 'active-result' : ''
                          }`}
                          onClick={() => setResultActive(!resultActive)}
                        >
                          <div className="row align-items-center h-100">
                            <div className="col-8 ps-5">
                              <label className="text-danger">
                                {importInfo?.importResult.importFails.length}
                              </label>
                              <p className="mb-0 text-danger">Import Fails</p>
                            </div>
                            <div className="col-4 text-center">
                              <img
                                src="../../../images/backoffice/fails.png"
                                width={50}
                                alt="Fails icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`logs-info block-shadow  ${
                      resultActive ? 'logs-info-show' : ''
                    }`}
                  >
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Employee ID</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importInfo?.importResult.importFails.map(
                          (item: any, key: number) => (
                            <tr key={key}>
                              <td>{item.id}</td>
                              <td>{item.indexKey}</td>
                              <td>{item.description}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </Table>
                  </div>
                </>
              ) : importStatus &&
                importInfo &&
                importInfo?.importResult.importSuccesses.length > 0 ? (
                <Alert key="success" variant="success" className="message p-2">
                  Import Successfully{' '}
                  {importInfo?.importResult.importSuccesses.length} Requests.
                </Alert>
              ) : (
                <></>
              )}
            </>
          )}

          {uploading ? (
            <div className="loader fileuploader text-center pt-3 min-h-253">
              {/* <div className="spinner m-auto"></div> */}
              <ProgressBar
                className="mx-5"
                now={progress}
                animated
                label={`${progress.toFixed(2)}%`}
              />
              <label className="mt-2">Waiting for uploading ...</label>
            </div>
          ) : (
            <FileUploader
              multiple={false}
              handleChange={handleChange}
              name="file"
              types={fileTypes}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={editModalShow}
        onHide={() => setEditModalShow(false)}
        size="lg"
        centered
        backdrop="static"
        aria-labelledby="edit-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="edit-modal-title">Edit Remark & Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Remark</label>
            <Form.Control
              as="textarea"
              rows={3}
              value={editRemark}
              onChange={e => setEditRemark(e.target.value)}
              placeholder="Enter remark"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Status</label>
            <Form.Select
              value={editStatus}
              onChange={e => setEditStatus(Number(e.target.value))}
            >
              {statusOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Form.Select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditModalShow(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEditSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      {pageLoder ? (
        <div className="pageLoder">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <ToastContainer />
    </>
  );
};
